import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { Breakpoint  } from "@mui/system";
import React from "react"


interface Props<T> {
    title: string;
    open: boolean;
    maxWidth: Breakpoint;
    onSubmit: () => void;
    formWidth: string | number;
    actionButtons?: React.ReactElement;
    loading: boolean;
    onDismiss: () => void;
    children: React.ReactNode;
}


export function FormDialog<T>(props: Props<T>): React.ReactElement<Props<T>> {
    const {
        title,
        open,
        maxWidth,
        onSubmit,
        formWidth,
        actionButtons,
        loading,
        onDismiss,
        children,
    } = props;

    let buttons = actionButtons
    if (buttons == null) {
        buttons = (
            <>
            <Button onClick={onDismiss} autoFocus>
                Fechar
            </Button>

            <Button
                disabled={loading}
                variant="contained"
                onClick={onSubmit}
            >
                {loading ? <CircularProgress /> : 'Salvar'}
            </Button>
            </>
        )
    }

    return (
        <Dialog 
            open={open}
            maxWidth={maxWidth}
            onClose={onDismiss}
        >
            <DialogTitle sx={{borderBottom: 1, borderColor: "divider"}}>
                {title}
            </DialogTitle>
            <Box 
                component="form"
                sx={{
                    '& .MuiFormControl-root': { m: 1, width: "80%"},
                }}
                onSubmit={onSubmit}
            >
                <DialogContent className="DialogContent">
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: formWidth,
                            alignItems: "center"
                        }}
                    >
                        {children}
                    </Box>
                </DialogContent>
                <DialogActions>
                    {buttons}
                </DialogActions>
            </Box>
        </Dialog>
    )
}